import { SCORM } from "pipwerks-scorm-api-wrapper";
import PersistenceError from "../../errors/PersistenceError";
import persistenceErrors from "../../constants/errors/peristenceErrors";

//convenience wrapper for pipwerks SCORM api that will throw exceptions of operations fail
export default class ScormWrapper {

	static init() {
		if (!SCORM.init()) {
			throw new PersistenceError(persistenceErrors.SCORM_INIT_FAILED.code, persistenceErrors.SCORM_INIT_FAILED.message);
		}
	}

	static get(path) {
		return SCORM.get(path);
	}

	static save() {
		if (!SCORM.save()) {
			throw new PersistenceError(persistenceErrors.SCORM_SAVE_FAILED.code, persistenceErrors.SCORM_SAVE_FAILED.message);
		}
	}

	static set(path, value) {
		if (!SCORM.set(path, value)) {
			throw new PersistenceError(persistenceErrors.SCORM_SET_FAILED.code, persistenceErrors.SCORM_SET_FAILED.message({ path: path, value: value }));
		}
	}

	static quit() {
		SCORM.quit();
	}
}